import { ChevronLeft, ChevronRight } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface PaginationProps {
  offset: number
  limit: number
  total: number
  onPageChange: (newOffset: number) => void
}

export function Pagination({ offset, limit, total, onPageChange }: PaginationProps) {
  const { t } = useTranslation('common')
  const currentPage = Math.floor(offset / limit) + 1
  const totalPages = Math.ceil(total / limit)

  if (totalPages <= 1) return null

  return (
    <div className="flex items-center justify-between text-sm text-text-secondary">
      <span>
        {t('pagination.showing', {
          from: offset + 1,
          to: Math.min(offset + limit, total),
          total,
        })}
      </span>
      <div className="flex items-center gap-1">
        <button
          onClick={() => onPageChange(Math.max(0, offset - limit))}
          disabled={offset === 0}
          className="rounded p-1 hover:bg-surface-elevated disabled:opacity-40"
        >
          <ChevronLeft className="h-4 w-4" />
        </button>
        <span className="px-2">
          {currentPage} / {totalPages}
        </span>
        <button
          onClick={() => onPageChange(offset + limit)}
          disabled={offset + limit >= total}
          className="rounded p-1 hover:bg-surface-elevated disabled:opacity-40"
        >
          <ChevronRight className="h-4 w-4" />
        </button>
      </div>
    </div>
  )
}
